import { useRef, useCallback } from 'react'
import { QRCodeCanvas } from 'qrcode.react'
import { IconButton, Stack } from 'rsuite'
import { ImDownload3 } from 'react-icons/im'
import { MdOpenInNew } from 'react-icons/md'

const QRCode = ({ value, qrSize = 1000, width = 300, showDownloadQrCodeButton, showLinkButton, className }) => {
  const canvasRef = useRef()
  const downloadRef = useRef()
  const openRef = useRef()

  const handleDowload = useCallback(() => {
    if (canvasRef) {
      const imageURL = canvasRef.current.toDataURL('image/png')
      const link = downloadRef.current
      link.href = imageURL
      link.click()
    }
  }, [canvasRef, downloadRef])

  const handleOpen = useCallback(() => {
    if (openRef) {
      const link = openRef.current
      link.href = value
      link.click()
    }
  }, [openRef, value])

  const renderQrCode = () => (
    <QRCodeCanvas value={value} size={qrSize} ref={canvasRef} style={{ width, height: width }} className={className} />
  )

  return showDownloadQrCodeButton || showLinkButton ? (
    <Stack className="gap10 row" alignItems="flex-start">
      {renderQrCode()}
      <Stack direction="column" className="gap10 column">
        {showDownloadQrCodeButton && <IconButton size="lg" icon={<ImDownload3 />} onClick={handleDowload} />}
        {showLinkButton && <IconButton size="lg" icon={<MdOpenInNew />} onClick={handleOpen} />}
      </Stack>
      {showDownloadQrCodeButton && (
        <button type="button" style={{ display: 'none' }} ref={downloadRef} aria-label="Download QR code" />
      )}
      {showLinkButton && (
        <button type="button" style={{ display: 'none' }} ref={openRef} aria-label="Open QR code link" />
      )}
    </Stack>
  ) : (
    <>{renderQrCode()}</>
  )
}

export default QRCode
